var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEndpointTestnetWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5V1.5H1V8.5C1 9.03043 1.21071 9.53914 1.58579 9.91421C1.96086 10.2893 2.46957 10.5 3 10.5C3.53043 10.5 4.03914 10.2893 4.41421 9.91421C4.78929 9.53914 5 9.03043 5 8.5V1.5H5.5V0.5H0.5ZM2.5 7.5C2.2 7.5 2 7.3 2 7C2 6.7 2.2 6.5 2.5 6.5C2.8 6.5 3 6.7 3 7C3 7.3 2.8 7.5 2.5 7.5ZM3.5 5.5C3.2 5.5 3 5.3 3 5C3 4.7 3.2 4.5 3.5 4.5C3.8 4.5 4 4.7 4 5C4 5.3 3.8 5.5 3.5 5.5ZM4 3H2V1.5H4V3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEndpointTestnetWhite);
export default __webpack_public_path__ + "static/media/icon-endpoint-testnet-white.ded3a5f88b172b7a7f0d37e4194f8061.svg";
export { ForwardRef as ReactComponent };